import React from 'react';

import CTA from 'react-scale/components/elements/cta';

import SectionSlider from './slider';

import { solutionsHeroLogo } from '../svg';

const Hero = ({ title, subtitle, heroColor, logo, ctas, slides }) => (
  <div className="container py-12 lg:py-16 lg:mb-7">
    <div className="grid items-center grid-cols-1 lg:grid-cols-2 gap-x-5 xl:gap-x-0">
      <div className="mb-10 lg:mb-0">
        <h1 className="mb-4 text-3xl font-aeonik lg:leading-normal lg:text-6xl">
          <span>{title.normal} </span>
          <span className="block text-gradient">{title.strong}</span>
        </h1>
        <p className="mb-12 text-lg text-neutral-300 md:text-xl lg:leading-relaxed lg:pr-16">
          {subtitle}
        </p>
        <CTA cta={ctas} />
      </div>
      {logo && (
        <div className="relative" style={{ maxHeight: 650 }}>
          <div
            className="absolute top-0 right-0 w-full h-full"
            style={{ background: heroColor.bg, maxWidth: heroColor.width }}
          />
          {solutionsHeroLogo[logo]}
        </div>
      )}
      {slides && <SectionSlider images={slides} bleeds={false} />}
    </div>
  </div>
);

Hero.defaultProps = {
  ctas: {
    buttons: [
      {
        href: 'https://dashboard.scale.com/signup',
        text: 'Get Started',
        type: 'primary'
      },
      {
        href: '/sales',
        text: 'Book a Demo',
        type: 'secondary'
      }
    ],
    hubspotForm: false,
    hubspotModal: false
  }
};

export default Hero;
